import axios from 'axios';
// import { setupCache } from 'axios-cache-adapter';
// import localforage from 'localforage';
import {
  LOCAL_STORAGE_CONSTANT,
  PUBLIC_PRIVATE_COMBINED,
} from '../constants/app';
import { getItem, setItem } from '../utils/cache';
import { clearDataAndRedirectToLogin } from '../utils/helpers';

// Create a localforage instance for caching
// const forageStore = localforage.createInstance({
//   driver: [localforage.INDEXEDDB, localforage.LOCALSTORAGE],
//   name: 'axios-cache',
// });

/**
 * Configure core axios instance with cache
 * */
export const baseURL =
  `${process.env.REACT_APP_API_BASE_URL}` || 'https://api.jen.health';

export const secondBaseURL =
  `${process.env.REACT_APP_SECOND_API_BASE_URL}` || '';

// const cache = setupCache({
//   maxAge: 1 * 60 * 1000, // Cache duration in milliseconds (e.g., 1 minutes)
//   exclude: { query: false }, // Cache requests with query parameters
//   store: forageStore, // Use localforage store
//   // debug: true, // Enable debug logging
// });

export function createAxiosInstace(url = baseURL) {
  console.log('url', url);
  console.log('baseURL', baseURL);
  console.log('secondBaseURL', secondBaseURL);
  return axios.create({
    baseURL: url,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      Accept: url.includes('community')
        ? 'application/json'
        : 'application/vnd.docjenfit.com; version=1',
      Source: 'web',
    },
    // adapter: cache.adapter, // Use cache adapter
  });
}

const makeErrorHandler = instance => async err => {
  const originalConfig = err.config;
  if (
    !['/auth/login', '/otps/verify'].includes(originalConfig.url) &&
    err.response
  ) {
    // Access Token was expired
    if (err.response.status === 401 && !originalConfig._retry) {
      originalConfig._retry = true;
      try {
        // Refresh always goes through the primary API
        const refreshInstance = createAxiosInstace();
        const response = await refreshInstance.post('/auth/refresh');
        const user = response?.data?.response?.data;
        const session = response?.headers;
        setItem(LOCAL_STORAGE_CONSTANT.USER, JSON.stringify(user));
        setItem(LOCAL_STORAGE_CONSTANT.SESSION, JSON.stringify(session));
        overrideHeader();
        overrideCommunityHeader();
        originalConfig.headers.uid = session.uid;
        originalConfig.headers.client = session.client;
        originalConfig.headers['access-token'] = session['access-token'];
        return instance(originalConfig);
      } catch (_error) {
        if (!PUBLIC_PRIVATE_COMBINED.includes(window.location.pathname)) {
          clearDataAndRedirectToLogin();
          return Promise.reject(_error);
        }
      }
    } else if (
      err.response.status === 401 &&
      !['/auth/login', '/otps/verify'].includes(err?.response?.config?.url) &&
      !PUBLIC_PRIVATE_COMBINED.includes(window.location.pathname)
    ) {
      clearDataAndRedirectToLogin();
      return Promise.reject(err);
    }
  }
  return Promise.reject(err);
};

const makeOverrideHeader =
  instance =>
  (type = 'session') => {
    const session = JSON.parse(getItem(type));
    if (!session) return;
    instance.defaults.headers.common.uid = session.uid;
    instance.defaults.headers.common.client = session.client;
    instance.defaults.headers.common['access-token'] = session['access-token'];
  };

export const axiosInstance = createAxiosInstace(baseURL);
export const communityAxiosInstance = createAxiosInstace(secondBaseURL);

export const overrideHeader = makeOverrideHeader(axiosInstance);
export const overrideCommunityHeader = makeOverrideHeader(
  communityAxiosInstance,
);

axiosInstance.interceptors.response.use(
  res => res,
  makeErrorHandler(axiosInstance),
);
communityAxiosInstance.interceptors.response.use(
  res => res,
  makeErrorHandler(communityAxiosInstance),
);

export const resetAxiosInstance = () => {
  ['uid', 'client', 'access-token'].forEach(key => {
    delete axiosInstance.defaults.headers.common[key];
  });
  // .clear() is axios 1.x's supported API; the old code reached into the
  // undocumented `handlers` array.
  axiosInstance.interceptors.response.clear();
};
